module.exports = __webpack_public_path__ + "img/icon-like.47f117ca.svg";